import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '../auth-section/auth-service/auth.service';
import { take } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { AppointmentService } from '../appointment-section/appointment-service/appointment.service';

@Component({
  selector: 'app-lab-reports',
  templateUrl: './lab-reports.component.html',
  styleUrls: ['./lab-reports.component.css']
})
export class LabReportsComponent implements OnInit {
  // @Input() onUploadFile: () => void;
  @Input() apptId: String;
  @Output() onFileSelect = new EventEmitter<any>();
  isDragging = false;
  fileover = false;
  token:String;
  id:String;
  appointmentId:String;
  constructor( private authService: AuthService,private apptService:AppointmentService,private route:ActivatedRoute) { }
  ngOnInit(): void { 
    this.authService.authDataSubject.pipe(take(1)).subscribe((auth) => {
      this.token = auth._token;
      this.id = auth._id;
      this.getSingleAppt(this.token);
    });
  }
  

  selectedFile: File | null = null;
  selectedFileUrl: string | ArrayBuffer | null = null;
  onFileSelected(event: Event): void {
    console.log("file selected");
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      const file = inputElement.files[0];
      console.log(inputElement);
      
      this.selectedFile = file;
      this.onuploadFile();
      this.selectedFileUrl = URL.createObjectURL(file);
    }
  }
  async getSingleAppt(token){
    var getData = await this.apptService.getSingleApptByappointmentId(this.apptId,token).subscribe((res:any)=>{
      console.log("this is appointment",res.data);
      
    })
  }
  getPatientAppointment(doctorId){

  }
  onuploadFile(){
    this.onFileSelect.emit(this.selectedFile);
  }
  // onDragOver(event: DragEvent): void {
  //   event.preventDefault();
  // }
  @HostListener('dragover', ['$event']) onDragover(evt) {
    evt.preventDefault(); // Notice the corrected preventDefault method call
    evt.stopPropagation();
    console.log('Drag over');
    this.fileover = true;
    // Dragleave listener
  }
  
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault(); // Corrected preventDefault method call
    evt.stopPropagation();
    console.log('Drag Leave');
    this.fileover = false;
    // Drop listener
  }
  
  @HostListener('drop', ['$event']) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileover = false;
    const files = evt.dataTransfer.files[0];
    this.selectedFile = files;
    this.onuploadFile();
    if (files.length > 0) {
      // Do Some stuff here
      console.log(`You dropped ${files.length} files.`);
    }
  }
  
}
